import { Typography } from '@mui/material';

export function NoOptionExist(): JSX.Element {
  return (
    <Typography variant='subtitle2' gutterBottom color='textSecondary'>
      There is no option
    </Typography>
  );
}
